import React,{useEffect,useState} from 'react';
import {Image} from 'react-native';
import {ModelIcon} from './ModelIcon';
import type {LocalSessionState,LocalTrackerSession} from './local-session';
type Props={state:LocalSessionState;session:LocalTrackerSession};
export function useDevicePhoto({state,session}:Props){
 const id=state.snapshot?.device?.id,revision=state.snapshot?.device?.photoRevision??0,scope=`${state.accountEmail}:${id}:${revision}`;
 const [photo,setPhoto]=useState<{scope:string;uri:string|null}|null>(null),[error,setError]=useState(false),[retry,setRetry]=useState(0);
 useEffect(()=>{let alive=true;setError(false);if(!state.signedIn||!state.snapshot?.device?.capabilities?.devicePhoto)return;
  void session.readDevicePhoto().then(result=>{if(alive&&result)setPhoto({scope,uri:result.dataUri});}).catch(()=>{if(alive)setError(true);});return()=>{alive=false;};
 },[scope,state.signedIn,state.snapshot?.device?.capabilities?.devicePhoto,session,retry]);
 return {uri:state.signedIn&&photo?.scope===scope?photo.uri:null,error,retry:()=>setRetry(n=>n+1),id,revision,scope};
}
export function DeviceImage({size=52,...props}:Props&{size?:number}){
 const {uri}=useDevicePhoto(props);
 return uri?<Image source={{uri}} resizeMode="cover" style={{width:size,height:size,borderRadius:size/2}}/>:<ModelIcon profile={props.state.snapshot?.device?.profile} size={size}/>;
}

export function ListedDeviceImage({device,session,accountEmail,size=36}:{device:{id:string;profile?:{model?:string};photoRevision?:number};session:LocalTrackerSession;accountEmail:string|null;size?:number}){
 const scope=`${accountEmail}:${device.id}:${device.photoRevision??''}`;
 const [photo,setPhoto]=useState<{scope:string;uri:string|null}|null>(null);
 useEffect(()=>{let active=true;if(!accountEmail||device.photoRevision===0)return;
  void session.readListedDevicePhoto(device.id).then(value=>{if(active&&value)setPhoto({scope,uri:value.dataUri});}).catch(()=>{});
  return()=>{active=false;};
 },[scope,session]);
 const uri=photo?.scope===scope?photo.uri:null;
 return uri?<Image accessibilityLabel={device.profile?.model??'Qtracker'} source={{uri}} resizeMode="cover" style={{width:size,height:size,borderRadius:size/2}}/>:<ModelIcon profile={device.profile} size={size}/>;
}
